export default function SearchTagsController($stateParams, $scope, searchTagsService, NotificationService, UtilService, SEARCH_TAGS_TYPES) {
  const vm = this;

  vm.merchantId = $stateParams.merchantId;
  vm.merchantTags = [];
  vm.orderedTagsByType = [];
  vm.isLoading = false;
  vm.showCashOnlyEnabledMessage = null;

  vm.SEARCH_TAGS_TYPES = SEARCH_TAGS_TYPES;

  vm.MANDATORY_FIELDS = [
    SEARCH_TAGS_TYPES.ESTABLISHMENT_TYPE,
    SEARCH_TAGS_TYPES.MEAL_TYPE,
    SEARCH_TAGS_TYPES.ATMOSPHERE,
    SEARCH_TAGS_TYPES.INTERNET,
    SEARCH_TAGS_TYPES.FOOD_RELATED
  ];

  vm.init = init;
  vm.updateTagsList = updateTagsList;
  vm.saveSearchTags = saveSearchTags;
  vm.checkSearchTagCheckboxes = checkSearchTagCheckboxes;
  vm.isDisabled = isDisabled;
  vm.capitalizeTagType = (tagType) =>
    tagType
      .split(' ')
      .map(substr => `${substr.charAt(0)}${substr.slice(1).toLowerCase()}`)
      .join(' ');

  const listener = $scope.$on('merchant.tab.searchTags.selected', () => {
    vm.init();
  });

  function init() {
    listener();
    vm.isLoading = true;
    searchTagsService.getMerchantTags(vm.merchantId).then(res => {
      vm.merchantTags = res.data.searchTags;
      searchTagsService
        .getAllTags()
        .then(res => {
          setTags(res.data.searchTags);
          validateMerchantTags();
          initPaymentOptions();
        })
        .catch(err => {
          NotificationService.error('Error getting merchant Tags: ', err);
        })
        .finally(() => {
          vm.isLoading = false;
        });
    });
  }

  function sortTagsLexically(tagSet) {
    return tagSet.sort((a, b) => {
      // Remove whitespace and uppercase characters to avoid unexpected sort ordering.
      const prev = a.name.replace(/\s+/g, '').toLowerCase();
      const next = b.name.replace(/\s+/g, '').toLowerCase();
      if (prev < next) return -1;
      if (prev > next) return 1;
      return 0;
    });
  }

  function setTags(searchTags) {
    const filteredSearchTags = searchTags.filter(
      tag => tag.tagType !== SEARCH_TAGS_TYPES.PRICE && tag.tagType !== SEARCH_TAGS_TYPES.CUISINE,
    );
    const tagsByType = filteredSearchTags.reduce((map, tag) => {
      map[tag.tagType] ? map[tag.tagType].push(tag) : (map[tag.tagType] = [tag]);
      map[tag.tagType] = sortTagsLexically(map[tag.tagType]);
      return map;
    }, {});
    vm.orderedTagsByType = tagsByType;
  }

  function validateMerchantTags() {
    const filterMerchantTagsByType = (tagType) => vm.merchantTags.filter(tag => tag.tagType === tagType);
    const establishmentProps = filterMerchantTagsByType(SEARCH_TAGS_TYPES.ESTABLISHMENT_TYPE);
    const merchantMealTags = filterMerchantTagsByType(SEARCH_TAGS_TYPES.MEAL_TYPE);
    const merchantAtmosphereTags = filterMerchantTagsByType(SEARCH_TAGS_TYPES.ATMOSPHERE);
    const merchantInternetTags = filterMerchantTagsByType(SEARCH_TAGS_TYPES.INTERNET);
    const merchantParkingTags = filterMerchantTagsByType(SEARCH_TAGS_TYPES.PARKING);
    const foodRelatedTags = filterMerchantTagsByType(SEARCH_TAGS_TYPES.FOOD_RELATED);

    vm.hasTooManyEstablishmentType = establishmentProps.length > 4;
    vm.hasTooManyAtmosphereTags = merchantAtmosphereTags.length > 7;
    vm.hasTooManyParkingTags = merchantParkingTags.length > 2;
    vm.hasEstablishmentType = establishmentProps.length;
    vm.hasMealTags = merchantMealTags.length;
    // New validation rules for automated OC descriptions
    vm.hasInternetTags = merchantInternetTags.length;
    vm.hasAtmosphereTags = merchantAtmosphereTags.length;
    vm.hasFoodRelatedTags = foodRelatedTags.length;
  }

  function initPaymentOptions() {
    const merchantHasCashOnlyTag = findCashOnlyTag(vm.merchantTags);

    if (merchantHasCashOnlyTag) {
      vm.showCashOnlyEnabledMessage = true;

      // we disable all payment tags except Cash Only
      vm.orderedTagsByType.PAYMENT.forEach(paymentTag => {
        paymentTag.disabled = true;
      });
      findCashOnlyTag(vm.orderedTagsByType.PAYMENT).disabled = false;
    }
  }

  function findCashOnlyTag(tagsArray) {
    return tagsArray.find(cashOnlyTag => cashOnlyTag.name === SEARCH_TAGS_TYPES.CASH_ONLY_TAG_NAME);
  }

  function isDisabled() {
    return vm.isLoading
        || vm.hasTooManyEstablishmentType
        || vm.hasTooManyAtmosphereTags
        || vm.hasTooManyParkingTags
        || !vm.hasEstablishmentType
        || !vm.hasMealTags
        || !vm.hasInternetTags
        || !vm.hasAtmosphereTags
        || !vm.hasFoodRelatedTags;
  }

  function checkSearchTagCheckboxes(searchTag) {
    return vm.merchantTags.find(tag => tag.id === searchTag.id);
  }

  function updateTagsList(tag) {
    const elementById = UtilService.findElementById(vm.merchantTags, tag.id);

    if (tag.name === SEARCH_TAGS_TYPES.CASH_ONLY_TAG_NAME) {
      //depend Cash Only selected we toggle or not all other payment methods.
      vm.showCashOnlyEnabledMessage = !vm.showCashOnlyEnabledMessage;
      tag.disabled = !tag.disabled;

      vm.orderedTagsByType.PAYMENT.forEach(paymentTag => {
        paymentTag.disabled = !paymentTag.disabled;
        UtilService.deleteElementById(vm.merchantTags, paymentTag.id);
      });
    }

    if (elementById && elementById !== -1) {
      UtilService.deleteElementById(vm.merchantTags, tag.id);
    } else {
      vm.merchantTags.push(tag);
    }
    validateMerchantTags();
  }

  function saveSearchTags() {
    if (vm.isLoading) {
      return;
    }

    vm.isLoading = true;

    searchTagsService
      .updateMerchantTags(vm.merchantId, vm.merchantTags)
      .then(function() {
        NotificationService.success('Tags updated');
      })
      .finally(function() {
        vm.isLoading = false;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/searchTags/searchTags.controller.js